module.exports = __webpack_public_path__ + "img/b3.3d981199.png";